import { useSelector, useDispatch } from "react-redux";
import LoyaltyOptInModal from "../../components/LoyaltyOptInModal";
import {
  getLoyaltyIsOptedIn,
  getLoyaltyIsEnabled,
  getEnableComplianceVariant,
  getStoreCode
} from "../../state/modules/config/selectors";
import {
  analyticsLoyaltyOptInClick,
  analyticsLoyaltyOptInReject
} from "../../state/modules/analytics/actions";

import { getCategoryDetails } from "../../state/modules/category";
import { loyaltyOptIn } from "../../state/modules/config/actions";
import { getFeatures } from "../../featuresStore";

const ConnectedLoyaltyOptInModal = props => {
  const loyaltyIsOptedIn = useSelector(getLoyaltyIsOptedIn);
  const categoryDetails = useSelector(getCategoryDetails);
  const loyaltyIsEnabled = useSelector(getLoyaltyIsEnabled);
  const enableComplianceVariant = useSelector(getEnableComplianceVariant);
  const storeCode = useSelector(getStoreCode);
  const dispatch = useDispatch();

  const { decisions } = getFeatures() || {};
  const loyaltyNewInExperimentEnabled = Boolean(
    decisions?.["loyalty-new-in-today-lock-product"]
  );

  return (
    <LoyaltyOptInModal
      {...props}
      loyaltyBenefitType={categoryDetails.loyaltyBenefit?.type}
      enableComplianceVariant={enableComplianceVariant}
      loyaltyIsEnabled={loyaltyIsEnabled}
      loyaltyIsOptedIn={loyaltyIsOptedIn}
      loyaltyNewInExperimentEnabled={loyaltyNewInExperimentEnabled}
      storeCode={storeCode}
      loyaltyOptIn={() => dispatch(loyaltyOptIn())}
      analyticsLoyaltyOptInClick={() => dispatch(analyticsLoyaltyOptInClick())}
      analyticsLoyaltyOptInReject={() =>
        dispatch(analyticsLoyaltyOptInReject())
      }
    />
  );
};

export default ConnectedLoyaltyOptInModal;
